import { Box, Paragraph, Table } from '@zillow/constellation-10';
import StringConstants from '../../../../constants/StringConstants';

const TOO_MANY_DISPLAY_MESSAGE_SUFFIX =
  'Try filtering by property or a shorter time frame, or export up to 15,000 of your most recent leads.';
const TOO_MANY_CONTACTS_MESSAGE = `Too many contacts to display. ${TOO_MANY_DISPLAY_MESSAGE_SUFFIX}`;
const TOO_MANY_LEADS_MESSAGE = `Too many leads to display. ${TOO_MANY_DISPLAY_MESSAGE_SUFFIX}`;

type Props = {
  children: React.ReactElement[];
  hasError: boolean;
  hasNoLeads: boolean;
  isEnterpriseCustomer: boolean;
  isAtPaginationCap?: boolean;
};

const TableContentWrapper = ({
  children,
  hasError,
  hasNoLeads,
  isEnterpriseCustomer,
  isAtPaginationCap = false,
}: Props) => {
  const errorMessage = isEnterpriseCustomer ? TOO_MANY_CONTACTS_MESSAGE : StringConstants.GENERIC_ERROR;

  return (
    <>
      {hasError || hasNoLeads ? (
        <Box
          css={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBlock: 'loose',
            textAlign: 'center',
          }}
        >
          {hasError ? <Paragraph>{errorMessage}</Paragraph> : <Paragraph>There are no leads to display.</Paragraph>}
        </Box>
      ) : (
        <>
          <Table.Responsive>
            <Table.Root aria-label="Leads" appearance="horizontal">
              {children}
            </Table.Root>
          </Table.Responsive>
          {isAtPaginationCap && (
            <Box
              css={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 'loose',
                textAlign: 'center',
              }}
            >
              <Paragraph textStyle="body-sm">
                {isEnterpriseCustomer ? TOO_MANY_CONTACTS_MESSAGE : TOO_MANY_LEADS_MESSAGE}
              </Paragraph>
            </Box>
          )}
        </>
      )}
    </>
  );
};

export default TableContentWrapper;
